import { Box, Checkbox, Typography } from "@mui/material";
import React from "react";
import ValueCounter from "../ValueCounter";
import * as Styled from "./styles.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomSlider from "../Slider/index.jsx";
import AutoScrollAccordion from "../AutoScrollAccordion";

function MarginBox({
  margin = {
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
  },
  increaseMargin,
  decreaseMargin,
  isApplyMarginOnAllSides,
  handleMarginCheckBox,
  allSideMargin,
  handleSliderMarginChange,
  fullWidth,
  handleMarginChange = () => {},
  onlyVerticalMargins = false,
  maxSliderValue = 100,
  symbol,
  checkbox = true,
  containerStyle = {},
  AccordionContainerStyle = {},
  applyButton = false,
  handleApplyChanges = () => {},
  hideSlider = false,
}) {
  const marginsToRender = onlyVerticalMargins
    ? ["Top", "Bottom"]
    : ["Top", "Bottom", "Left", "Right"];
  
  return (
    <div>
      <AutoScrollAccordion
        title={"Margin"}
        AccordionSummaryStyle={{
          p: 0,
          m: 0,
        }}
        AccordionContainerStyle={AccordionContainerStyle}
        RightIconComponent={ExpandMoreIcon}
        isTootTipShow={true}
        toolTipDescription={`The space outside the element's border, creating external space between the element and its surroundings.`}
      >
        <Styled.Container style={containerStyle}>
          {!onlyVerticalMargins && checkbox && (
            <Styled.Header>
              <Styled.CheckboxContainer>
                {/* <Checkbox
                  style={{ marginTop: "-15px" }}
                  checked={isApplyMarginOnAllSides}
                  onClick={handleMarginCheckBox}
                />

                <Styled.ApplyText>Apply to all slides</Styled.ApplyText> */}
              </Styled.CheckboxContainer>
            </Styled.Header>
          )}

          {isApplyMarginOnAllSides && !hideSlider ? (
            <>
              <CustomSlider
                value={allSideMargin}
                onChange={(value) => handleSliderMarginChange(value)}
                max={maxSliderValue}
                symbol={symbol}
              />
            </>
          ) : (
            <Styled.RowDiv>
              {marginsToRender.map((side, index) => (
                <ValueCounter
                  key={index}
                  title={side}
                  value={margin[side.toLowerCase()]}
                  onClickIncrease={() => increaseMargin(side.toLowerCase())}
                  onClickDecrease={() => decreaseMargin(side.toLowerCase())}
                  disabled={fullWidth && (side == "Left" || side == "Right")}
                  handleChange={handleMarginChange}
                />
              ))}
            </Styled.RowDiv>
          )}
        </Styled.Container>
      </AutoScrollAccordion>

      {applyButton && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              cursor: "pointer",
              color: "#9B5AF8",
              transition: "all 0.2s ease-in-out",
              fontSize: "16px",
              fontWeight: "500",
              fontFamily: "DM Sans",

              "&:hover": {
                scale: "1.05",
                transition: "all 0.2s ease-in-out",
              },
            }}
            onClick={handleApplyChanges}
          >
            Apply
          </Typography>
        </Box>
      )}
    </div>
  );
}

export default MarginBox;
